import instance from 'utils/axios/instance.axios';
import { MIDTERM_REVIEW } from './_constant';

export const getGeneralProjectProposalInfo = (councilId, projectProposalId, referenceId = null) =>
  instance.get(MIDTERM_REVIEW.GET_PROJECT_PROPOSAL_INFO, {
    params: { councilId, projectProposalId, referenceId },
  });

export const getReviewerInfo = (userId, councilId, projectProposalId) =>
  instance.get(MIDTERM_REVIEW.GET_REVIEWER_INFO, {
    params: { userId, councilId, projectProposalId },
  });

export const getDetail = (councilMemberId, councilId, projectProposalId) =>
  instance.get(MIDTERM_REVIEW.GET_DETAIL, {
    params: { councilMemberId, councilId, projectProposalId },
  });

export const createMidtermReview = (data = {}) =>
  instance.post(MIDTERM_REVIEW.CREATE_MIDTERM_REVIEW, data);

export const updateMidtermReview = (data = {}) =>
  instance.patch(MIDTERM_REVIEW.UPDATE_MIDTERM_REVIEW, data);

export const submit = (data = {}) => instance.patch(MIDTERM_REVIEW.SUBMIT_MIDTERM_REVIEW, data);

// Download review file

export const getDetailFile = (councilMemberId, councilId, projectProposalId) =>
  instance.get(MIDTERM_REVIEW.GET_DETAIL_FILE, {
    params: { councilMemberId, councilId, projectProposalId },
  });

export const downloadFile = (body = {}) =>
  instance.post(MIDTERM_REVIEW.DOWNLOAD_FILE, body, { responseType: 'blob' });

export const downloadPdfFile = ({
  projectProposalId,
  referenceId = null,
  councilId,
  councilMemberId,
}) =>
  instance.post(
    MIDTERM_REVIEW.DOWNLOAD_PDF_FILE,
    {
      projectProposalId,
      referenceId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );

export const downloadPdfTemplate = ({
  projectProposalId,
  referenceId = null,
  councilId,
  councilMemberId,
}) =>
  instance.post(
    MIDTERM_REVIEW.DOWNLOAD_PDF_TEMPLATE,
    {
      projectProposalId,
      referenceId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );

export const downloadDocxFile = ({
  projectProposalId,
  referenceId = null,
  councilId,
  councilMemberId,
}) =>
  instance.post(
    MIDTERM_REVIEW.DOWNLOAD_DOCX_FILE,
    {
      projectProposalId,
      referenceId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );

export const downloadDocxTemplate = ({
  projectProposalId,
  referenceId = null,
  councilId,
  councilMemberId,
}) =>
  instance.post(
    MIDTERM_REVIEW.DOWNLOAD_DOCX_TEMPLATE,
    {
      projectProposalId,
      referenceId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );
